module.exports = __webpack_public_path__ + "images/marketing_site/user_setup.png";